<template>
    <div class="view confirmregistration"></div>
</template>

<script>

export default {
  name: 'view-auth-confirm-registration',
  created () {
    const userId = this.$route.params.userId
    const code = this.$route.params.code
    this.$store.dispatch('authUserConfirmSelfRegistration', { userId, code }).then(() => {
      this.$store.dispatch('defaultNotificationToastsAdd', {
        title: 'Confirm registration',
        message: `You have successfully confirmed registration. You can now log in.`,
        status: 'success'
      })
    }).catch(() => {
      this.$store.dispatch('defaultNotificationToastsAdd', {
        title: 'Confirm registration',
        message: `Something went wrong while confirming registration. Try again or contact an administrator.`,
        status: 'error'
      })
    }).finally(() => {
      this.$router.push({ name: 'auth-login' })
    })
  }
}
</script>
